import { render, staticRenderFns } from "./video-embed.vue?vue&type=template&id=ef9d57ec&"
import script from "./video-embed.vue?vue&type=script&lang=js&"
export * from "./video-embed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports